import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Switch, Redirect, Route, } from 'react-router-dom';
import Credit from './Credit';
import PlasticCard from './PlasticCard';
import Account from './Account';
import List from './POS/List';
import Order from './POS/Order';
import NotFound from '../../../copms/NotFound/NotFound';

class CreateTransferConvertation extends Component {
    render() {
        let { updateAppState, updateDashboardState, alertState, logout, isBankCustomer } = this.props;

        return (
            <Switch>
                <Redirect exact from="/dashboard/orders/" to={isBankCustomer ? "/dashboard/orders/plastic-card" : "/dashboard/orders/account"} />
                <Redirect exact from="/dashboard/orders/pos" to="/dashboard/orders/pos/list" />
                {/* <Route path="/dashboard/orders/credit" render={(routeProps) => <Credit logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} /> */}
                <Route path="/dashboard/orders/plastic-card" render={(routeProps) => <PlasticCard logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                {localStorage.getItem('checkResident') === "1" && localStorage.getItem("isAsan") === "true" &&
                    <Route path="/dashboard/orders/account" render={(routeProps) => <Account logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                }
                {localStorage.getItem('compId') && <>
                    <Route path="/dashboard/orders/pos/list" render={(routeProps) => <List logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} />
                    <Route path="/dashboard/orders/pos/order" render={(routeProps) => <Order logout={() => logout()} {...routeProps} updateAppState={updateAppState} updateDashboardState={updateDashboardState} alertState={alertState} />} /></>
                }
                <Route render={(routeProps) => (<NotFound />)} />
            </Switch>
        )
    }
}

export default translate("translation")(CreateTransferConvertation);
